import { Map, OrderedMap } from 'immutable';
import React from 'react';
import InstrumentFleetTable from './instrument-fleet-table/InstrumentFleetTable';

export type Props = {
  instruments: OrderedMap<string, Map<string, any>>;
  projectId: string;
  selectedFleetToggle: string;
  setFleetToggleCallback: (e: string) => void;
  statuses: Map<string, Map<string, any>>;
  fetchMoreData: (...args: Array<any>) => any;
  isLoading: boolean;
  isError: boolean;
};

export default function FleetManagement(props: Readonly<Props>) {
  const {
    instruments,
    projectId,
    selectedFleetToggle,
    setFleetToggleCallback,
    statuses,
    fetchMoreData,
    isLoading,
    isError
  } = props;
  return (
    <InstrumentFleetTable
      instruments={instruments}
      projectId={projectId}
      selectedFleetToggle={selectedFleetToggle}
      setFleetToggleCallback={setFleetToggleCallback}
      statuses={statuses}
      fetchMoreData={fetchMoreData}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
